/**
 * @author RamaTulasi <rama.tulasi@sollishealth.com>
 */
import { useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import ContactModal from "./ContactModal";
import MessageModal from "./MessageModal";
import { storeMemberDetails } from "../../features/memberDetailsSlice";
import {
  getMemberDetails,
  GetUnReadLabResultCount,
  GetUnReadMessageCount
} from "../../services/RestApi";
import { resetAppointmentDetails } from "../../features/appointmentDetailsSlice";
import Geocode from "react-geocode";
import { API_KEY } from "../../utilities/Constants";
import { useOnlineStatus } from "../../utilities/useOnlineStatus";
import { hideLoader, showLoader } from "../../utilities/Loader";
import { checkVersionDiff } from "../../utilities/helper";
import { datadogRum } from "@datadog/browser-rum";
import { useImpersonation } from "../../components/impersonation-provider";
import { DashboardRouterButton as DocumentCenterButton } from "features/document-center";
import FooterCompliance from "components/FooterCompliace";

function Home() {
  const _memberDetails = useSelector((state) => state.memberDetails);
  const isOnline = useOnlineStatus(); //network connection status
  const dispatch = useDispatch();
  const [memberDetails, setMemberDetails] = useState(_memberDetails);
  const { accounts } = useMsal();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openContacts, setOpenContacts] = useState(false);

  const [patientIds, setPatientIds] = useState([]);
  const [messagesCount, setMessagesCount] = useState();
  const [labResultCount, setLabResultCount] = useState();
  const [isAvailable, setIsAvailable] = useState(false);
  const [labResultCountLoading, setLabResultCountLoading] = useState(false);
  const { isImpersonating, user } = useImpersonation();

  Geocode.setApiKey(API_KEY);
  Geocode.setLocationType("ROOFTOP");
  let greyOutAreas = false;

  const messages = () => {
    let path = `messages/1`;
    history.push(path);
  };
  const routeChange = () => {
    let path = `labresults`;
    history.push(path);
  };
  const SpecialistReferralList = () => {
    let path = `specialistreferrallist`;
    history.push(path);
  };

  /**
   * Getting the member details from the store and handover to the current state
   */

  useEffect(() => {
    setMemberDetails(_memberDetails);
  }, [_memberDetails]);

  useEffect(() => {
    const user = {
      id: accounts[0].idTokenClaims?.oid,
      name: accounts[0].name,
      email: accounts[0].username,
    };
    console.log(user);
    datadogRum.setUser(user);
  }, []);

  /**
   * Getting memberdetails baseed on current username and sending data to store
   */
  useEffect(() => {
    showLoader();
    dispatch(resetAppointmentDetails());
    let data = {
      emailId: accounts[0]?.username,
    };
    //  let data = {
    // 	"emailId": 'memberportaluser1@gmail.com'
    // };
    if (!_memberDetails.loginMember.length) {
      getMemberDetails(data)
        .then((res) => {
          checkVersionDiff(dispatch, res);
          dispatch(storeMemberDetails(res.data?.data[0]));
          setMemberDetails(res.data?.data[0]);
          _getPatientIds(res.data?.data[0]);
          setIsAvailable(true);
          hideLoader();
        });
    } else {
      let md = JSON.parse(JSON.stringify(_memberDetails));
      md.loginMember[0].type = "In-Clinic";
      dispatch(storeMemberDetails(md));
      setMemberDetails(_memberDetails);
      _getPatientIds(_memberDetails);
      setIsAvailable(true);
      hideLoader();
    }
  }, []);

  /**
   *
   * @param {*} _members :Existing Members
   * Retreving the patient id's based on the members added in the multimember page
   */
  const _getPatientIds = (_members) => {
    let patientids = [],
      patientDetails = [];

    let members = _members;


    patientids.push({
      patientid: members.loginMember[0].patientID,
      memberId: members.loginMember[0].memberID,
    });

    patientDetails[members.loginMember[0].patientID] = {
      memberUsername: members.loginMember[0].memberUsername,
    };

    members.dependents.forEach((dependent) => {
      if (dependent.selected) {
        patientids.push({
          patientid: dependent.patientID,
          memberId: dependent.memberID,
        });
        patientDetails[dependent.patientID] = {
          memberUsername: dependent.memberUsername,
        };
      }
    });

    setPatientIds(patientids);
    return patientids;
  };

  /**
   * Getting the appointments for all loggedin member and dependents, sending all these details to the store
   */
  useEffect(() => {
    // let data = {
    // 	"practiceid": 195900,
    // 	"patientid": [{
    // 		"patientid":1
    // 	}]
    // }
    let messageData = {
      params: {
        status: "Inbox",
      },
    };
    GetUnReadMessageCount(messageData)
      .then((res) => {
        checkVersionDiff(dispatch, res);
        res.data?.count ? setMessagesCount(res.data.count) : setMessagesCount();
      })
      .catch(() => {});
    let LabResultsData = {
      memberIds: isImpersonating
        ? [user.id]
        : [memberDetails?.loginMember[0]?.memberID],
    };
    GetUnReadLabResultCount(LabResultsData)
      .then((res) => {
        checkVersionDiff(dispatch, res);
        res.data?.totalCount
          ? setLabResultCount(res.data.totalCount)
          : setLabResultCount(0);
        setLabResultCountLoading(false);
      })
      .catch(() => {});
  }, [patientIds, isImpersonating, user]);

  /**
   * Getting the bills, messages and lab result unread count
   */

  useEffect(() => {
    let memberIds = [
      {
        memberID: memberDetails?.loginMember[0]?.memberID,
      },
    ];
    let memberIdsForLabCount = [memberDetails?.loginMember[0]?.memberID];
    memberDetails?.dependents?.map((it) => {
      if (it.selected === true) {
        memberIds.push({ memberID: it.memberID });
        memberIdsForLabCount.push(it.memberID);
      }
    });
    let LabResultsData = {
      memberIds: memberIdsForLabCount,
    };
    let messageData = {
      params: {
        status: "Inbox",
      },
    };
    if (isAvailable) {
      setLabResultCountLoading(true);
      GetUnReadLabResultCount(LabResultsData)
        .then((res) => {
          checkVersionDiff(dispatch, res);
          res.data?.totalCount
            ? setLabResultCount(res.data.totalCount)
            : setLabResultCount(0);
          setLabResultCountLoading(false);
        })
        .catch(() => {});
      GetUnReadMessageCount(messageData)
        .then((res) => {
          checkVersionDiff(dispatch, res);
          res.data?.count
            ? setMessagesCount(res.data.count)
            : setMessagesCount();
        })
        .catch(() => {});
    }
  }, [isAvailable, memberDetails]);
  const toggle = () => {
    setOpen(!open);
  };
  const callToggle = () => {
    setOpenContacts(!openContacts);
  };
  return (
    <div className="Home margin-top-large">
      <Container className="solis-home">
        {/* Breadcrumb */}
        <Row className="portfolio">
          <Col className="mx-auto row">
            <div className="immediate-care">
              <div style={{ width: "100%", textAlign: "center" }}>
                <h1>Immediate Care</h1>
                <p>Available 24/7</p>
              </div>

              {/*<button className={`button-action btn-border ${!isOnline ? `btn-disable` : ""}`} onClick={toggle}>
                                <i className="fa-light fa-message-lines"></i>
                            </button> */}
              <button
                style={{ width: "100%", maxWidth: "20em" }}
                className={`button-action ${!isOnline ? `btn-disable` : ""}`}
                onClick={callToggle}
              >
                <i className="fa-light fa-phone"></i>
              </button>
            </div>
          </Col>
        </Row>
        <Row className="row whitebg appointment">
          <Col lg="6" className="appointment-label" onClick={messages}>
            <i className="icon fa-light fa-envelope-open-text" />
            <p>
              Messages{" "}
              {messagesCount ? (
                <span className="count">{messagesCount}</span>
              ) : (
                ""
              )}
            </p>

            <i className="fa-light fa-chevron-right" />
          </Col>
          <Col lg="6" className="appointment-label" onClick={routeChange}>
            <i className="icon fa-light fa-hospital-user" />
            <p>
              Test Results{" "}
              {labResultCountLoading ? (
                <div className="working appointmentsloader"></div>
              ) : typeof labResultCount == "number" && labResultCount > 0 ? (
                <span className="count">{labResultCount}</span>
              ) : (
                ""
              )}
            </p>
            <i className="fa-light fa-chevron-right" />
          </Col>

          <Col
            lg="6"
            className="appointment-label"
            onClick={SpecialistReferralList}
          >
            <i className="icon fa-light fa-user-doctor" />
            <p>Specialist Referral</p>
            {greyOutAreas && <i className="fa-light fa-chevron-right" />}
          </Col>
          <DocumentCenterButton />
          {/* 
                    <Col
                        lg="6"
                        className={`appointment-label disable ${
                            !isOnline ? `text-disable` : ''
                        }`}
                        onClick={greyOutAreas ? billing : undefined}
                    >
                        <i className="icon fa-light fa-file-invoice-dollar" />
                        <p>
                            Billing{' '}
                            {greyOutAreas && billCount ? (
                                <span className="count">{billCount}</span>
                            ) : (
                                ''
                            )}
                        </p>
                        {greyOutAreas && <i className="fa-light fa-chevron-right" />}
                    </Col> */}
        </Row>
        <div className="footer-call">
          <FooterCompliance />
        </div>
      </Container>
      <ContactModal modal={openContacts} toggle={callToggle} />
      <MessageModal modal={open} toggle={toggle} />
    </div>
  );
}

export default Home;
